import { UserState } from './types';
import User from '../../types/auth/User';

export default {
  getUser(state: UserState): User {
    return state.user;
  }
};
